import MaterialTableBody from "../../../../../__snowpack__/pkg/@mui/material/TableBody.js";
import React from "react";
import TableRow from "../table-row/table-row.component.js";
function TableBody({
  data,
  headers,
  onRowSelect,
  selectable,
  fixSelect,
  selectedRows = [],
  ...rest
}) {
  return /* @__PURE__ */ React.createElement(MaterialTableBody, rest, data.map((item) => {
    const checked = selectedRows.indexOf(item.id) !== -1;
    return /* @__PURE__ */ React.createElement(TableRow, {
      headers,
      checked,
      item,
      key: item.id,
      onRowSelect,
      selectable,
      fixSelect
    });
  }));
}
export default /* @__PURE__ */ React.memo(TableBody);
